<template>
  <v-card flat>
    <v-card-title>
      <span class="headline">{{ data.id ? 'Edit' : 'Add' }} Subscription</span>
      <v-spacer></v-spacer>
      <v-btn
        icon
        small
        @click="$emit('close-dialog')"
      >
        <v-icon>
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="mt-5">
      <v-form>
        <v-autocomplete
          v-model="data.customer_id"
          outlined
          :menu-props="{ offsetY: true }"
          :items="customersList"
          :error-messages="errorMessages.customer_id"
          dense
          :filter="customerFilter"
          item-text="company_name"
          item-value="id"
          placeholder="Select Customer"
          label="Customer"
        >
          <template slot="selection" slot-scope="slotData">
            {{ slotData.item.company_name }} (<small>{{ slotData.item.contact_person }}</small>)
          </template>
          <template slot="item" slot-scope="slotData">
            {{ slotData.item.company_name }} (<small>{{ slotData.item.contact_person }}</small>)
          </template>
        </v-autocomplete>

        <v-select
          v-model="data.subscription_type_id"
          outlined
          :menu-props="{ offsetY: true }"
          :items="subscriptionTypes"
          :error-messages="errorMessages.subscription_type_id"
          dense
          item-text="name"
          item-value="id"
          placeholder="Select Subscription Type"
          label="Subscription Type"
        ></v-select>

        <v-text-field
          v-model="data.name"
          outlined
          dense
          label="Subscription Name (optional)"
          placeholder="Enter subscription name"
          :error-messages="errorMessages.name"
        ></v-text-field>

        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="data.next_renewal_date"
              outlined
              dense
              label="Next Renewal Date"
              placeholder="Select date"
              readonly
              v-bind="attrs"
              v-on="on"
              :error-messages="errorMessages.next_renewal_date"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="data.next_renewal_date"
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>

        <v-text-field
          v-model.number="data.price"
          outlined
          dense
          type="number"
          min="0"
          label="Subscription Price"
          placeholder="Enter price"
          :error-messages="errorMessages.price"
          @input="val => { data.price = Math.abs(val) }"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="py-5">
      <v-btn
        color="error"
        outlined
        @click="$emit('close-dialog')"
      >
        Close
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click="saveSubscription()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  mdiPlus,
  mdiClose
} from '@mdi/js'
import { ref, onUnmounted } from '@vue/composition-api'
import invoiceStoreModule from '../invoiceStoreModule'
import store from '@/store'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    subscriptionTypes: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) {
      store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const customersList = ref([])
    const dateMenu = ref(false)
    const errorMessages = ref([])

    store.dispatch('app-invoice/fetchClients', {
    }).then(response => {
      customersList.value = response.data
    }).catch(error => {
      console.log(error)
    })

    const customerFilter = (item, queryText, itemText) => {
      return (
        item.company_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.contact_person.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      )
    }

    const saveSubscription = () => {
      errorMessages.value = []

      if (!props.data.hasOwnProperty('id')) {
        store
          .dispatch('app-invoice/addSubscription', props.data)
          .then(response => {
            store.dispatch("addNotification", { message: "Subscription was saved.", type: "success" })
            emit('close-dialog')
            emit('refresh-list')
          })
          .catch(error => {
            errorMessages.value = error.response.data.error
          })
      } else {
        store
          .dispatch('app-invoice/updateSubscription', props.data)
          .then(response => {
            store.dispatch("addNotification", { message: "Subscription was updated.", type: "success" })
            emit('close-dialog')
            emit('refresh-list')
          })
          .catch(error => {
            errorMessages.value = error.response.data.error
          })
      }
    }

    return {
      customersList,
      customerFilter,
      dateMenu,
      saveSubscription,
      errorMessages,

      icons: {
        mdiPlus,
        mdiClose
      },
    }
  }
}
</script>

<style lang="css" scoped>
</style>


